export const IMAGES = [
  { src: "https://i.ibb.co/BqFWk1q/2.jpg", thumbnail: "https://i.ibb.co/BqFWk1q/2.jpg" },
  { src: "https://i.ibb.co/Kr7PSxk/3.jpg", thumbnail: "https://i.ibb.co/Kr7PSxk/3.jpg" },
  { src: "https://i.ibb.co/cyLk3PK/4.jpg", thumbnail: "https://i.ibb.co/cyLk3PK/4.jpg" },
];
